/**
 * test-bridge 环境开关
 *
 * 生产硬阻断（C1，评审 v2.1 修订）：NODE_ENV=production 时恒 false，置最前，
 * 不依赖 tree-shake 正确性 —— 即使业务代码直接调用 isTestBridgeEnabled()，
 * 生产也恒禁用，防止 URL 参数 __test_bridge__=1 在生产泄露 form values。
 *
 * Rspack 注入点：apps/mpc-inner/.umirc.ts DefinePlugin + define 两处，
 * 'process.env.APP_TEST_BRIDGE_ENABLED' 须 JSON.stringify 包裹（A9 落地）。
 */

const TEST_BRIDGE_URL_FLAG = '__test_bridge__=1';
const ENV_TRUE = 'true';
const ENV_TEST = 'test';
const ENV_PROD = 'production';

export const isTestBridgeEnabled = (): boolean => {
  // C1 生产硬阻断：即使被业务代码直接调用也恒 false
  if (process.env.NODE_ENV === ENV_PROD) return false;
  return (
    process.env.NODE_ENV === ENV_TEST ||
    process.env.APP_TEST_BRIDGE_ENABLED === ENV_TRUE ||
    (typeof window !== 'undefined' && window.location?.search.includes(TEST_BRIDGE_URL_FLAG))
  );
};
